module.exports = __webpack_public_path__ + "assets/595096d0f225b71b7c12f5c0f6d33225.svg";